interface PageTypes {
  BROADCAST: string;
  REGULAR: string;
  GROUP: string;
  AI: string;
  IOT: string;
}

export const PAGE_TYPES: PageTypes = {
  BROADCAST: "broadcast",
  REGULAR: "regular",
  GROUP: "group",
  AI: "ai",
  IOT: "iot",
};

export enum MENU_ITEM_IDs {
  CreatePage = 1,
  Broadcast = 2,
  First = 3,
  EventCreator = 4,
  ProjectEventCreator = 5,
  CallCenter = 6,
  Calendar = 7,
  Ride = 8,
  Dashboard = 9,
  Friends = 10,
  Video = 11,
  Admin = 12,
  School = 13,
  Shuttle = 14,
  Medical = 15,
  Coach = 16,
  Lighthouse = 17,
  Ai = 18,
  IoT = 19,
  Customer = 20,
  School2 = 21,
  Coupon = 22,
  Fleet = 23,
  CFO = 24,
}

export enum FilterOption {
  PLACE = "place",
  ASSET = "asset",
  USER = "user",
  MEDIA = "media",
  PAGE = "page",
  GPS = "gps",
  EVENT = "event"
}